import React, { ChangeEvent, useState } from 'react';
import styles from './NoAuth.module.css';

interface FormComponentProps {
    formData: {
        country: string;
        city: string;
        zipCode: string;
        address: string;
    };
    handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
    handleFormSubmit: () => void;
    loading: boolean;
}

const FormComponent: React.FC<FormComponentProps> = ({ formData, handleChange, handleFormSubmit, loading }) => {

    const isFormValid = (): boolean => {
        return Object.values(formData).every(value => value.trim() !== '');
    };

    const handleSubmit = () => {
        if (isFormValid()) {
            handleFormSubmit();
        }
    };

    return (
        <>
            <div className={styles.flex}>
                <input
                    className={styles.otpBox}
                    type="text"
                    name="country"
                    value={formData.country}
                    placeholder="Country"
                    onChange={handleChange}
                />
                <input
                    className={styles.otpBox}
                    type="text"
                    name="city"
                    value={formData.city}
                    placeholder="City"
                    onChange={handleChange}
                />
                <input
                    className={styles.otpBox}
                    type="text"
                    name="zipCode"
                    value={formData.zipCode}
                    placeholder="Zip code"
                    onChange={handleChange}
                />
                <input
                    className={styles.otpBox}
                    type="text"
                    name="address"
                    value={formData.address}
                    placeholder="Address"
                    onChange={handleChange}
                />
            </div>
            <button
          className={styles.otp_button}
          onClick={handleSubmit}
          disabled={!isFormValid() || loading}
        >
                {loading ? 'Loading...' : 'Submit'}
        </button>
            
        </>
    );
};

export default FormComponent;
